import { createSlice } from "@reduxjs/toolkit";

export const partieSlice = createSlice({
  name: "partie",
  initialState: [],
  reducers: {
    ajoutRole: (state, action) => {
      state.push(action.payload);
    },
    enleveRole: (state, action) => {
      return state.filter((x) => x.order !== action.payload);
    },
    modifieJoueur: (state, action) => {
      const { index, value } = action.payload;
      if (state[index]) {
        state[index] = value; // Immer modifie en place
      }
    },
    modifieJoueurParOrder: (state, action) => {
      const { order, joueur } = action.payload;
      const index = state.findIndex((item) => item.order === order);
      if (index !== -1) {
        state[index] = { ...state[index], Joueur: joueur };
      }
    },
    trierPartie: (state) => {
      state.sort((a, b) => {
        if (!a.Joueur && b.Joueur) return 1;
        if (a.Joueur && !b.Joueur) return -1;
        if (!(a.Joueur ^ b.Joueur)) return a.order - b.order;
        return 0;
      });
    },
  },
});

export const {
  ajoutRole,
  enleveRole,
  modifieJoueur,
  modifieJoueurParOrder,
  trierPartie,
} = partieSlice.actions;

export default partieSlice.reducer;
